/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Brand_Manufacturer1Inputs */

const vi_sitesettings_brand_manufacturer1 = /** @type {(inputs: Sitesettings_Brand_Manufacturer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị sản xuất (trang sản phẩm)`)
};

/**

* @param {Sitesettings_Brand_Manufacturer1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_brand_manufacturer1 = /** @type {((inputs?: Sitesettings_Brand_Manufacturer1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Brand_Manufacturer1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_brand_manufacturer1(inputs)
});
export { sitesettings_brand_manufacturer1 as "siteSettings_brand_manufacturer" }